import { render, staticRenderFns } from "./UninstallScreenNew.vue?vue&type=template&id=675cd8fa"
import script from "./UninstallScreenNew.vue?vue&type=script&lang=js"
export * from "./UninstallScreenNew.vue?vue&type=script&lang=js"
import style0 from "./UninstallScreenNew.vue?vue&type=style&index=0&id=675cd8fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports